/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { DayPickerRangeController } from 'react-dates'

const Wrapper = styled.div`
  padding-bottom: 24px;

  .DayPicker {
    margin: 0 auto;
    box-shadow: none;
  }
`

const DatesFilterInputs = ({ onChange, show, ...props }) => {
  const [values, setValues] = useState({
    startDate: props.startDate ? moment(props.startDate) : null,
    endDate: props.endDate ? moment(props.endDate) : null,
  })
  const { startDate, endDate } = values

  const [focusedInput, setFocusedInput] = useState('startDate')

  const handleDatesChange = (newDates) => {
    setValues(newDates)
    onChange(newDates)
  }

  useEffect(() => {
    setValues({
      startDate: props.startDate ? moment(props.startDate) : null,
      endDate: props.endDate ? moment(props.endDate) : null,
    })
  }, [props.startDate, props.endDate])

  return (
    <Wrapper>
      {show && (
        <DayPickerRangeController
          daySize={40}
          startDate={startDate}
          endDate={endDate}
          startDateId="startDate"
          endDateId="endDate"
          onDatesChange={handleDatesChange}
          onFocusChange={(input) => {
            setFocusedInput(!input ? 'startDate' : input)
          }}
          focusedInput={focusedInput}
          displayFormat="DD MMM YY"
          numberOfMonths={1}
          firstDayOfWeek={1}
          hideKeyboardShortcutsPanel
          isOutsideRange={(day) => day.isBefore(moment().startOf('day'))}
          transitionDuration={0} // Fix for iOS 14
        />
      )}
    </Wrapper>
  )
}

export default DatesFilterInputs
